var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 0C7.442 0 3.736 3.647 3.736 8.16c0 4.512 3.706 8.16 8.264 8.16s8.264-3.648 8.264-8.16C20.264 3.647 16.558 0 12 0Zm0 3.333c2.729 0 4.93 2.167 4.93 4.827S14.73 12.986 12 12.986c-2.729 0-4.93-2.167-4.93-4.826C7.07 5.5 9.27 3.333 12 3.333Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12.986c4.714 0 9.074 2.477 11.437 6.504a1.667 1.667 0 1 1-2.874 1.687C18.8 18.173 15.536 16.319 12 16.319c-3.536 0-6.8 1.854-8.563 4.858a1.667 1.667 0 1 1-2.874-1.688C2.926 15.462 7.286 12.986 12 12.986Z"
}))));
export default SvgProfile;